function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.3 69.7V.5h13.4c-.349 22.285.426 49.662 0 68.3v.9zm-16.8 0V.5h4.6v69.2zm-17 0V.5h9.8v69.2zm88.6-.657l-12.358-.036L76.2.5h13.4zM59.6.5h5.8l-.405 68.502-4.813-.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.1 1v68.043l-12.4-.135V.9h12.4M64.8 1l.195 68.002-4.813-.006L60 1h4.8M47.2 1c.195 4.492.381 54.975 0 67.9v.3H34.8V1h12.4M21.6 1v68.2H18V1h3.6M9.8 1v68.2H1V1h8.8m80.3-1H75.8v70.23l14.4-.032V0zM65.8 0H59l.365 70.143 6.435-.009zM48.2 0H33.8v70.2h14.4v-1.5c-.114-23.309 0-44.056 0-68.7zM22.6 0H17v70.2h5.6zM10.8 0H0v70.2h10.8z"
}));

function SvgScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.2,
    height: 70.23,
    viewBox: "0 0 90.2 70.23"
  }, props), _ref);
}

export default SvgScan;